import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { baseMaps } from '../../utils/mapConfig';
import PurpleCar from 'assets/images/icons/tracking-truck.webp';

export default function MiniMap({ lat, lon, angle = 0 }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current) return;

    const validLat = parseFloat(lat);
    const validLon = parseFloat(lon);

    if (isNaN(validLat) || isNaN(validLon)) return;

    if (!mapInstanceRef.current) {
      // Initialize map
      const map = L.map(mapRef.current, {
        center: [validLat, validLon],
        zoom: 16,
        attributionControl: false,
        layers: [baseMaps['Google Map'] || baseMaps['OpenStreetMap']]
      });

      // Add layer control
      L.control.layers(baseMaps).addTo(map);
      mapInstanceRef.current = map;

      // Fix for Leaflet CSS container conflict
      setTimeout(() => {
        map.invalidateSize();
      }, 300);
    }

    const map = mapInstanceRef.current;
    map.setView([validLat, validLon], 16);

    // Create rotated marker
    const iconHtml = `<img src="${PurpleCar}" style="width:36px; height: 18px; transform-origin: center; transform: rotate(${angle - 90}deg); z-index: 2; position: relative;" />`;
    const carIcon = L.divIcon({
      html: iconHtml,
      className: '',
      iconSize: [36, 18],
      iconAnchor: [18, 9]
    });

    if (markerRef.current) {
      markerRef.current.setLatLng([validLat, validLon]);
      markerRef.current.setIcon(carIcon);
    } else {
      markerRef.current = L.marker([validLat, validLon], { icon: carIcon }).addTo(map);
    }

    return () => {
      // Cleanup happens only when unmounted to prevent leaflet "Map container is already initialized" error
    };
  }, [lat, lon, angle]);

  // Real cleanup on unmount
  useEffect(() => {
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
        markerRef.current = null;
      }
    };
  }, []);

  return <div ref={mapRef} style={{ width: '100%', height: '100%', minHeight: '300px', borderRadius: '8px', zIndex: 1 }} />;
}
